angular.module('impactx.list').directive('ixServerSideList', function(){
    return {
        restrict: 'E',
        scope: {
            metaData: '='
        },
        templateUrl: 'shared/list/templates/list.html',
        controller: 'ServerSideListCtrl',
        controllerAs: 'listCtrl'
    }
});
